var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhysicalBlueFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 214,
    viewBox: "0 0 340 214",
    width: 340,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 18.012,
    x2: 48.5827,
    y1: 90.7274,
    y2: 129.595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4c4c4"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 32.2063,
    x2: 53.7322,
    y1: 91.6955,
    y2: 120.693
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0c0c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 41.587,
    x2: 283.407,
    y1: 0.000001,
    y2: 213.951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 16c0-8.83656 7.16344-16 16-16h308c8.837 0 16 7.16344 16 16v182c0 8.837-7.163 16-16 16h-308c-8.83656 0-16-7.163-16-16z",
    fill: "#191d23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 16c0-8.83656 7.16344-16 16-16h308c8.837 0 16 7.16344 16 16v182c0 8.837-7.163 16-16 16h-308c-8.83656 0-16-7.163-16-16z",
    fill: "#0091c7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m38 77.7369c0-2.1904 1.7757-3.9661 3.9662-3.9661h35.6955c2.1905 0 3.9662 1.7757 3.9662 3.9661v25.3831c0 2.191-1.7757 3.967-3.9662 3.967h-35.6955c-2.1905 0-3.9662-1.776-3.9662-3.967z",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m48.5625 73.7708v7.839h-10.5625v.9004h12.6291c1.3363 0 2.411.9172 2.411 2.0392v4.5286h-15.0401v.9005h15.0401v5.8395c0 1.122-1.0747 2.0392-2.411 2.0392h-12.6291v.9004h10.5625v8.1034h1.0333v-8.1034h1.0333c1.9023 0 3.4443-1.3161 3.4443-2.9396v-1.3374h10.907v1.3374c0 1.6216 1.5384 2.9365 3.4374 2.9396h-.2227v8.1034h1.0333v-8.1034h12.3995v-.9004h-13.2032c-1.3363 0-2.411-.9172-2.411-2.0392v-5.8395h15.6142v-.9005h-15.6142v-4.5286c0-1.122 1.0747-2.0392 2.411-2.0392h13.2032v-.9004h-12.3995v-7.839h-1.0333v7.8454c-1.7952.1009-3.2147 1.3755-3.2147 2.9332v.0265h-10.907v-.0265c0-1.6235-1.542-2.9396-3.4443-2.9396h-1.0333v-7.839zm16.4179 19.8094v-8.1039h-10.907v8.1039z",
    fill: "url(#b)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalBlueFront);
export default __webpack_public_path__ + "static/media/physical-blue-front.7895982d98d117e953bf07c3a3d88e63.svg";
export { ForwardRef as ReactComponent };